import { useState, useEffect } from "react";

import DetailsSection from "../../../components/composed/DetailsSection/DetailsSection";

import {
  apiResponseMiddleware,
  checkVisibility,
  getVisibleAndEditableFieldsConfig
} from "../../../services/ApiResponseMiddleware";

import { LoanApplicationService } from "../../../services/LoanApplication";
import { webSectionData } from "../Utilites/constant";

import { useLapTask } from "../../../pages/LAPTaskManagement/LapTaskManagementContext";

interface WebSectionProps {
  token: string;
  pageName: string;
  loanID: string;
  isLenderDashboard: boolean;
  pageConfig: any;
  whiteLabelStyle?: any;
  resourceName: string;
  service: string;
  data?: any;
  userID: string;
  notify: any;
  resourceNameSingleSubmit: string;
  lapStudio?: boolean;
  useLocation?: any;
  useNavigate?: any;
  isMFL_LAP: boolean;
  showCustomButton?: boolean;
}

let formDetails: any = {};

// used in loan overview only and GST Platform
const WebSection = (props: WebSectionProps) => {
  const {
    token,
    pageName,
    loanID,
    isLenderDashboard,
    pageConfig,
    resourceName,
    whiteLabelStyle,
    service,
    data,
    userID,
    notify,
    resourceNameSingleSubmit,
    lapStudio,
    useLocation,
    useNavigate,
    isMFL_LAP,
    showCustomButton
  } = props;

  let setTabData: any;
  if (lapStudio) ({ setTabData } = useLapTask() ?? {});

  const [formFields, setFormFields] = useState<any>(null);
  const [editableFields, setEditableFields] = useState<any>([]);
  const [configResponse, setConfigResponse] = useState<any>(null);

  const renderUIConfig = pageConfig?.[pageName!]?.renderUIConfig;
  const getConfig = async () => {
    const configResponse = await LoanApplicationService.getConfig({
      token,
      pageName,
      payload: { loanApplicationID: loanID, resourceName, service },
      isLenderDashboard
    });

    setConfigResponse(configResponse ?? {});
    formDetails = getVisibleAndEditableFieldsConfig(
      apiResponseMiddleware(configResponse)
    );
  };

  useEffect(() => {
    if (renderUIConfig) (async () => await getConfig())();
  }, [pageName, loanID, token, renderUIConfig]);

  useEffect(() => {
    if (configResponse?.data && renderUIConfig) {
      const transformedSectionData = [];
      for (let index = 0; index < formDetails?.sections?.length; index++) {
        const sectionData = formDetails?.sections[index];
        const data = {
          title: sectionData.label,
          key: sectionData.id,
          id: sectionData.id,
          isEditable: checkVisibility(sectionData?.buttonList?.edit),
          buttonList: sectionData?.buttonList,
          fieldList: (sectionData?.fieldList || []).map((field: any) => ({
            ...field,
            name: field.label,
            value: typeof field.value === "object" ? "" : field.value,
            key: field.id,
            id: field.id,
            ...(field.nestedfieldList && {
              nestedfieldList: field.nestedfieldList.map(
                (nestedField: any) => ({
                  ...nestedField,
                  name: nestedField.label,
                  value:
                    typeof nestedField.value === "object"
                      ? ""
                      : nestedField.value,
                  key: nestedField.id,
                  id: nestedField.id
                })
              )
            })
          })),
          itemType: sectionData?.itemType,
          componentType: sectionData?.componentType,
          componentLabel: sectionData?.componentLabel
        };

        if (sectionData.sectionSequence)
          transformedSectionData[sectionData?.sectionSequence - 1] = data;
        else transformedSectionData.push(data);
      }

      setFormFields(transformedSectionData);
      if (lapStudio) setTabData(transformedSectionData);

      setEditableFields(formDetails?.editableFieldsSectionWise || []);
    }
  }, [configResponse, resourceName, renderUIConfig, formDetails]);

  return (
    <div className="block p-4 md:overflow-auto">
      {(renderUIConfig && formFields !== null
        ? formFields
        : webSectionData
      )?.map((sectionData: any, idx: number) => (
        <DetailsSection
          key={sectionData.key}
          notify={notify}
          whiteLabelStyle={whiteLabelStyle}
          title={sectionData?.title}
          renderUIConfig={renderUIConfig}
          isEditable={renderUIConfig ? sectionData?.isEditable : false}
          items={
            renderUIConfig ? sectionData?.fieldList : data?.[sectionData?.key]
          }
          sectionData={sectionData || {}}
          editableFields={editableFields}
          userID={userID}
          tabName={"details_tab"}
          loanApplicationID={loanID}
          resourceName={resourceName}
          resourceNameSingleSubmit={resourceNameSingleSubmit}
          pageName={pageName}
          sectionID={sectionData?.id}
          isLenderPlatform={isLenderDashboard}
          token={token}
          isMFLLAP={isMFL_LAP}
          reload={getConfig}
          graphQLResponse={configResponse?.data?.ruleData?.graphQLResponse}
          uiElements={configResponse?.data?.ruleData}
          useLocation={useLocation}
          useNavigate={useNavigate}
          showCustomButton={showCustomButton}
          {...(renderUIConfig && {
            styles: {
              heading: "pl-2",
              keyValuePair: "pl-2",
              keys: "font-normal"
            },
            isFirstSection: idx === 0,
            accordion: true
          })}
        />
      ))}
    </div>
  );
};

export default WebSection;
